import React, { ComponentPropsWithRef, useContext } from 'react'
import { StatementCard } from '../StatementCard'
import { DraggableItemIF, DraggableList } from './DraggableList'
import { Assignation } from '../../context/types'
import type { TypographyVariant } from '../../types/mui'
import { useCommonCtx } from '../../context/useCommonCtx'
import { registerAutomation } from './dnd'
import { info, logException } from '../../services/sentryLogger'
import _ from 'lodash';
import { stms2str } from '../../utils/stm'

const omitter = (item: any) => _.omit(item, ['renderedComponent']);

interface Props extends ComponentPropsWithRef<'div'> {
    items: Assignation[]
    setItems: React.Dispatch<React.SetStateAction<Assignation[]>>
    big?: boolean
    stmProps?: (
        id: string,
        index: number,
        title: string
        // @ts-ignore TS2307
    ) => ComponentPropsWithRef<typeof StatementCard>
}


export const DraggableAssignationList = (p: Props) => {
    const {
        items = [],
        setItems,
        big = false,
        stmProps = (id, index, title) => ({
            showRank: true, //FIXME
        }),
    } = p
    const size = items.length
    let textSize: TypographyVariant = 'body2'

    const { state: {params} } = useCommonCtx()
    const myItems: DraggableItemIF<Assignation>[] = items.map((data, index) => {
        if (!data) {
            logException('DraggableAssignationList', 'data is null', 
            new Error(JSON.stringify(
                { data, index, items},
                null,
                ' '
            )))
            throw new Error('data is null')
        }
        const { id, title, category } = data
        // FIXME big props
        const renderedComponent = big ? (
            <StatementCard
                big
                showId={params.assessmentParams['debug_mode'] === 1}
                {...stmProps(id, index, title)}
                {...data}
                emoji={!!params.assessmentParams['values_with_icons']}
                // textSize={textSize}
                // iconSize={iconSize}
                id={id}
                index={index + 1}
                // title={`${index + 1}. ${title} ${''}`}
                title={title}
                onIncrease={() => {
                    setItems((prevItems) => {
                        const newItems: Assignation[] = [...prevItems]
                        const index = newItems.findIndex(
                            ({ id: loopId }) => loopId === id
                        )
                        const removedItem = newItems.splice(index, 1)[0]
                        removedItem.weight = (removedItem.weight ?? 0) + 1
                        const newIndex = Math.max(0, index - 1)
                        newItems.splice(newIndex, 0, removedItem)
                        return newItems
                    })
                }}
                onDecrease={() => {
                    setItems((prevItems) => {
                        const newItems: Assignation[] = [...prevItems]
                        const index = newItems.findIndex(
                            ({ id: index }) => index === id
                        )
                        const removedItem = newItems.splice(index, 1)[0]
                        removedItem.weight = (removedItem.weight ?? 0) - 1
                        const newIndex = Math.min(
                            prevItems.length - 1,
                            index + 1
                        )
                        newItems.splice(newIndex, 0, removedItem)
                        return newItems
                    })
                }}
            />
        ) : (
            <StatementCard
                // big
                draggable
                showId={params.assessmentParams['debug_mode'] === 1}
                {...stmProps(id, index, title)}
                {...data}
                emoji={!!params.assessmentParams['values_with_icons']}
                id={id}
                // textSize={textSize}
                // iconSize={iconSize}
                index={index + 1}
                // title={`${index + 1}. ${title} ${''}`}
                title={title}
                onIncrease={() => {
                    setItems((prevItems) => {
                        const newItems: Assignation[] = [...prevItems]
                        const index = newItems.findIndex(
                            ({ id: loopId }) => loopId === id
                        )
                        const removedItem = newItems.splice(index, 1)[0]
                        removedItem.weight = (removedItem.weight ?? 0) + 1
                        const newIndex = Math.max(0, index - 1)
                        newItems.splice(newIndex, 0, removedItem)
                        return newItems
                    })
                }}
                onDecrease={() => {
                    setItems((prevItems) => {
                        const newItems: Assignation[] = [...prevItems]
                        const index = newItems.findIndex(
                            ({ id: index }) => index === id
                        )
                        const removedItem = newItems.splice(index, 1)[0]
                        removedItem.weight = (removedItem.weight ?? 0) - 1
                        const newIndex = Math.min(
                            prevItems.length - 1,
                            index + 1
                        )
                        newItems.splice(newIndex, 0, removedItem)
                        return newItems
                    })
                }}
            />
        )
        return {
            id,
            index,
            title,
            data,
            renderedComponent,
        }
    })

    return (
        <DraggableList
            registerAutomation={registerAutomation}
            key={'pseudoHomeListId'}
            id={'pseudoHomeListId'}
            items={myItems}
            onChange={(newItems) => {
                setItems(prevItems => {
                    info('on change prev =', stms2str(prevItems));
                    info('on change new =', stms2str(newItems));
                    return newItems.map(({ data }) => data)
                })
            }}
            onDelete={console.log}
        />
    )
}
